//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['uid'],
    async fetch() {
        if (this.uid) {
            const {
                data: {
                    categories: { items },
                },
            } = await this.$axios.$get(`/categorytree/${this.uid}`);
            this.crumbs = items;
        } else {
            this.crumbs = [];
        }
    },
    data() {
        return { crumbs: [], showImage: true };
    },
    fetchOnServer: true,
};
